import EventDispatcher from './event-dispatcher';

export default EventDispatcher;
